import { defineStore } from 'pinia'
import { ref } from 'vue'
import { settingsAPI } from '../api/modules/settings.js'

export const useSettingsStore = defineStore('settings', () => {
  const maintenanceMode = ref(false)
  // Game on the maintenance page ('spice-jar' or 'flappy'), picked in the admin (Minihra)
  const maintenanceGame = ref('spice-jar')
  // Launch of the shop (ISO string): the maintenance page counts down to it, null = no countdown
  const launchAt = ref(null)
  // Guests can't check out, they are asked to sign up (admin-v2 Nastavenia)
  const ordersRegisteredOnly = ref(false)
  const initialized = ref(false)

  const fetchMaintenanceStatus = async () => {
    try {
      const data = await settingsAPI.getMaintenanceStatus()
      maintenanceMode.value = !!data.maintenance
      if (data.game) maintenanceGame.value = data.game
      launchAt.value = data.launch_at || null
      ordersRegisteredOnly.value = !!data.orders_registered_only
    } catch {
      // On error keep previous state
    }
    initialized.value = true
  }

  const setMaintenance = (value) => {
    maintenanceMode.value = value
  }

  const setMaintenanceGame = (value) => {
    maintenanceGame.value = value
  }

  const setShopSettings = (settings) => {
    if ('maintenance' in settings) maintenanceMode.value = !!settings.maintenance
    if ('launch_at' in settings) launchAt.value = settings.launch_at || null
    if ('orders_registered_only' in settings) ordersRegisteredOnly.value = !!settings.orders_registered_only
  }

  return {
    maintenanceMode,
    maintenanceGame,
    launchAt,
    ordersRegisteredOnly,
    initialized,
    fetchMaintenanceStatus,
    setMaintenance,
    setMaintenanceGame,
    setShopSettings,
  }
})
